import { styled, Flex, Box, StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

const DESKTOP_WIDTH = pxToRem(550);
const DESKTOP_HEIGHT = pxToRem(680);
const DESKTOP_SMALL_WIDTH = '48vw';
const DESKTOP_SMALL_HEIGHT = pxToRem(570);
const MOBILE_HEIGHT = pxToRem(390);

export const DESKTOP_TEXT_WIDTH = pxToRem(390);
export const MOBILE_TEXT_WIDTH = pxToRem(310);

const dialogOverrides = {
  Content: {
    props: {
      width: pxToRem(1100)
    }
  },
  Body: {
    props: {
      rowGap: 7,
      display: 'flex',
      overflow: 'hidden',
      borderRadius: {
        _: 0,
        sm2: pxToRem(12)
      },
      flexDirection: {
        _: 'column',
        sm2: 'row'
      }
    }
  },
  CloseButton: {
    props: {
      overrides: {
        Root: {
          props: {
            zIndex: 3,
            paddingX: 0,
            top: {
              _: 5,
              sm2: 7
            },
            right: {
              _: 4,
              sm2: 7
            },
            color: 'mono14',
            border: '1px solid',
            borderColor: 'mono5',
            backgroundColor: 'white'
          }
        }
      }
    }
  }
};

export const StyledMediaContainer = styled(Flex)``;
const mediaContainerStyles: StyleSystemProps = {
  overflow: 'hidden',
  position: 'relative',
  width: {
    _: '100%',
    sm2: DESKTOP_SMALL_WIDTH,
    md2: DESKTOP_WIDTH
  },
  height: {
    _: MOBILE_HEIGHT,
    sm2: 'auto'
  }
};

const medialLayoutStyles: CSSObject = {
  position: 'absolute',
  width: {
    _: '100%',
    sm2: DESKTOP_SMALL_WIDTH,
    md2: DESKTOP_WIDTH
  },
  height: {
    _: MOBILE_HEIGHT,
    sm2: DESKTOP_HEIGHT
  },
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)'
};

export const StyledBackgroundVideo = styled(Box)``;
const backgroundVideoStyles = ($backgroundImageUrl: Maybe<string>): CSSObject => ({
  ...medialLayoutStyles,
  backgroundImage: $backgroundImageUrl ? `url("${$backgroundImageUrl}")` : undefined,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  overflow: 'hidden',
  zIndex: 2,
  ['& iframe']: {
    ...medialLayoutStyles,
    width: {
      _: '100%',
      sm2: DESKTOP_WIDTH
    },
    height: {
      _: '100vw',
      sm2: '100%'
    }
  }
});

export const StyledTextContainer = styled(Flex)``;
const textContainerStyles: StyleSystemProps = {
  flexDirection: 'column',
  width: {
    _: '100%',
    sm2: DESKTOP_SMALL_WIDTH,
    md2: DESKTOP_WIDTH
  },
  height: {
    _: 'auto',
    sm2: DESKTOP_SMALL_HEIGHT,
    md2: DESKTOP_HEIGHT
  },
  justifyContent: 'center',
  alignItems: 'center',
  paddingX: 8
};

export const StyledTextContent = styled(Flex)``;
const textContentStyles: StyleSystemProps = {
  maxWidth: {
    _: MOBILE_TEXT_WIDTH,
    sm2: DESKTOP_TEXT_WIDTH
  },
  flexDirection: 'column',
  alignItems: 'flex-start'
};

export const styles = {
  dialogOverrides,
  mediaContainer: mediaContainerStyles,
  backgroundVideo: backgroundVideoStyles,
  textContainer: textContainerStyles,
  textContent: textContentStyles
};
